import React from "react";

function TONBlockchain() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose TON Blockchain?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  The Open Network (TON) is a cutting-edge blockchain ecosystem
                  designed to handle millions of transactions per second through
                  its unique sharding and workchain model. Originally designed
                  by Telegram, TON offers high throughput, low latency, and
                  scalable solutions ideal for various decentralized
                  applications (DApps), NFT projects, DeFi platforms, and
                  beyond.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default TONBlockchain;
